import React from 'react';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';
import DBABasicInfoComponent from './dba-basic-info.component';
import DBACatalogs from './dba-catalogs';
import DBADomainMappings from './dba-domain-mappings';
import DBACategoryMappings from './dba-category-mappings';
import DBACollectionMappings from './dba-collections-mappings';
import DBADiscountMappings from './dba-discount-mappings';
import DBAOrders from './dba-orders';
import DBADBNBizs from './dba-dbnbizs';
import DBABrandMappings from './dba-brand-mapping/containers/brand-mappings';
import DBAShipments from './dba-order-shipments/container/shipments';
import DBAReturnRequests from './dba-order-return-requests/containers/return-requests';
import DBAMappedWebsitesInfoComponent from './websites/dba-mapped-websites-info.component';
import DBAServices from './dba-services/containers/dba-services';
import DBACatalogLogsIndex from './dba-catalog-logs/dba-catalog-index';

export const DBAComponent = ({ websites, handleFormChange, selectedDba, handleInnerFormChange, accounts, back, handleFormSubmit, dbaId }: any) => {
  const tabItems = [
    {
      id: 0,
      title: `${selectedDba?.Name} - Basic Details`,
      component: <DBABasicInfoComponent
        handleInnerFormChange={handleInnerFormChange}
        selectedDba={selectedDba}
        handleFormChange={handleFormChange}
        accounts={accounts}
      />,
      isVisible: true,
    },
    {
      id: 1,
      title: 'Brand Mappings',
      component: <DBABrandMappings
        selectedDba={selectedDba}
      />,
      isVisible: true,
    },
    {
      id: 2,
      title: 'Domain',
      component: <DBADomainMappings
        selectedDba={selectedDba}
      />,
      isVisible: true,
    },
    {
      id: 3,
      title: 'Category',
      component: <DBACategoryMappings
        selectedDba={selectedDba}
      />,
      isVisible: true,
    },
    // {
    //   id: 4,
    //   title: 'Products',
    //   component: <DBAProducts
    //     selectedDba={selectedDba}
    //   />,
    //   isVisible: true,
    // },
    {
      id: 5,
      title: 'Catalog',
      component: <DBACatalogs
        selectedDba={selectedDba}
      />,
      isVisible: true,
    },
    {
      id: 6,
      title: 'Orders',
      component: <DBAOrders />,
      isVisible: true,
    },
    {
      id: 7,
      title: 'Orders - Shipments',
      component: <DBAShipments
        selectedDba={selectedDba}
      />,
      isVisible: true,
    },
    {
      id: 8,
      title: 'Orders - Return Requests',
      component: <DBAReturnRequests selectedDba={selectedDba} />,
      isVisible: true,
    },
    {
      id: 9,
      title: 'Mapped DBNBizs',
      component: <DBADBNBizs />,
      isVisible: true,
    },
    {
      id: 10,
      title: 'Collections',
      component: <DBACollectionMappings
        selectedDba={selectedDba}
      />,
      isVisible: true,
    },
    {
      id: 11,
      title: 'Discounts',
      component: <DBADiscountMappings dbaId={dbaId} />,
      isVisible: true,
    },
    {
      id: 12,
      title: 'Catalog Logs',
      component: <DBACatalogLogsIndex selectedDba={selectedDba} />,
      isVisible: true,
    },
    {
      id: 13,
      title: 'Mapped Websites Info',
      component: <DBAMappedWebsitesInfoComponent
        selectedDba={selectedDba}
        websites={websites} />,
      isVisible: true,
    },
    {
      id: 14,
      title: 'Services',
      component: <DBAServices
        selectedDba={selectedDba} />,
      isVisible: true,
    },
  ];

  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">

      <TabContainer tabItems={tabItems} />

      <div className='flex w-full justify-end items-end'>
        <button
          onClick={back}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Back
        </button>

      </div>
    </div>
  );
};

export default DBAComponent;
